import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { CvDto } from 'src/app/services/api-client/models/cv-dto';
import { CvRestControllerService } from 'src/app/services/api-client/services';
import { LanguageEnum } from 'src/app/shared/enums/language.model';

@Injectable()
export class CvResolver implements Resolve<CvDto> {

  constructor(
    public cvService: CvRestControllerService,
    public translate: TranslateService
  ) {}

  resolve(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<CvDto> {
    let updateLang: LanguageEnum;
    // Retrieve static language of page
    if(route.data.lang === 'en') {
      updateLang = LanguageEnum.ENGLISH;
    } else if(route.data.lang === 'de'){
      updateLang = LanguageEnum.GERMAN;
    } else {
      console.error("Sprache nicht unterstüzt");
    }
    if(updateLang) {
      console.log("Language routing change -> Reload CV");
      this.translate.use(route.data.lang)
      return this.cvService.getCvsByLanguage({language: updateLang});
    }
  }
}
